




























































import {
  Component, mapState, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import { CommonsStore } from '@samclick-store-factory';
import { _isEmpty, _last } from '@samclick-lodash';

@Component({
  /**
   * Imported components
   * */
  components: {
  },
  /**
   * Stores values
   * */
  computed: {
    ...mapState({
      loading: (state: any) => state.cpa.cpacommissionStore.loading,
    }),

  },
  /**
   * Component properties
   * */
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    cpaDtls: {
      type: Object,
      required: true,
    },
  },
})
export default class ViewTiers extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
  componentState = this.defaultState();

  /**
   * Watchers
   * */
  @Watch('$props.showDialog', { immediate: true })
  showDialogWatcher(newVal: string, oldVal: string) {
    if (newVal && !oldVal) {
      this.componentState.cpaDtls = this.clone(this.$props.cpaDtls);
    } else if (oldVal && !newVal) {
      this.componentState = this.defaultState();
    }
  }

  /**
   * Methods
   * */

  /**
   * Computed
   * */
  defaultState() {
    return {
      editMode: false,
      editIndex: 0,
      oldValOfEditingSets: {},
      cpaDtls: {
        tiers: [],
      },
      newRow: false,
      minWidth: "100",
      width: "500",
      columnWidth: "200",
    };
  }

  getCasinoDescription(id: number) {
    return CommonsStore.casinoAllDescription(id) ? CommonsStore.casinoAllDescription(id).code : '';
  }

  convertDate(date: string) {
    if (date === "0001-01-01T00:00:00Z") {
      return "-";
    }

    const newDate = new Date(date);
    const formatted = newDate.toLocaleDateString("en-CA");
    return formatted;
  }

  setMinMax(min: Number, max: Number) {
    if (min === max) {
      return min
    }
    return `${min} - ${max}`;
  }

  /**
   * Lifecycle hooks
   * */
  created() {

  }

  mounted() {}

  beforeUpdate() {}
}
